import { Vue } from 'vue-property-decorator';
import Vuex, { Store } from 'vuex';
import { sessionModule } from './sessionModule';
import { globalSearchModule } from "@/modules/main/store/globalSearchModule";
import { modalModule } from "@/modules/main/store/modalModule";
import { mobileMenuModule } from './mobileMenuModule';
Vue.use(Vuex);
export var store = new Store({
    modules: {
        session: sessionModule,
        globalSearch: globalSearchModule,
        modal: modalModule,
        mobileMenu: mobileMenuModule
    },
});
